import { render, staticRenderFns } from "./Turnover.vue?vue&type=template&id=bbc6947e&scoped=true"
import script from "./Turnover.vue?vue&type=script&lang=js"
export * from "./Turnover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc6947e",
  null
  
)

export default component.exports